export const translations = {
  ar: {
    // Header
    'header.title': 'نظام التحقق من الاشتراطات بالذكاء الاصطناعي',
    'header.settings': 'الإعدادات',
    'header.language': 'تغيير اللغة',
    
    // Footer
    'footer.disclaimer': 'هذه نسخة تجريبية غير مخصصة للاستخدام الإنتاجي وتهدف لاختبار التحقق من الاشتراطات بالذكاء الاصطناعي. لا تُعد المخرجات قرارًا نهائيًا. للاستخدام الداخلي للمصرح لهم فقط.',
    'footer.copyright': '©Barqium. جميع الحقوق محفوظة.',

    // Step 1 (Upload)
    'step1.title': 'الخطوة الأولى: رفع المستندات',
    'step1.description': 'يرجى رفع الملفات بصيغة PDF للتحقق منها ومعالجتها من قبل نظام بارقيوم الذكي.',
    'step1.dropzone': 'قم بسحب وإسقاط ملفات PDF هنا أو انقر للتصفح',
    'step1.dropzoneHint': 'الحد الأقصى لحجم الملف: 50 ميجابايت (صيغة PDF فقط)',
    'step1.browseFiles': 'تصفح الملفات من جهازك',
    'step1.uploadedFiles': 'الملفات المرفوعة',
    'step1.fileSize': 'ميجابايت',
    'step1.fileUploaded': 'تم الرفع',
    'step1.fileConverting': 'جاري التحويل...',
    'step1.convertButton': 'تحويل والمتابعة ←',
    'step1.converting': 'جاري التحويل...',
    'step1.loadingText': 'جاري تحويل ومعالجة المستندات',
    'step1.validation.noFiles': 'يرجى رفع ملف واحد على الأقل',
    'step1.validation.invalidType': 'الملفات التالية ليست من نوع PDF',
    'step1.validation.fileTooLarge': 'الملفات التالية تتجاوز الحد الأقصى (50MB)',
    'step1.validation.maxFiles': 'الحد الأقصى للملفات هو {max}. لديك {current} ملف وتحاول إضافة {adding}.',
    'step1.toast.convertSuccess': 'تم تحويل {count} ملف بنجاح',
    'step1.toast.convertFailed': 'فشل في تحويل الملفات',

    // Step 2 (Rules)
    'step2.title': 'الخطوة الثانية: تحديد الاشتراطات',
    'step2.description': 'يرجى إدخال وتحديد الاشتراطات لمعالجة المستندات والتحقق من الاشتراطات عبر نظام برقيوم',
    'step2.civilId': 'رقم الهوية الوطنية',
    'step2.civilIdPlaceholder': 'أدخل رقم الهوية',
    'step2.requesterName': 'اسم مقدم الطلب',
    'step2.requesterNamePlaceholder': 'أدخل الاسم الكامل',
    'step2.requestId': 'رقم الطلب',
    'step2.requestIdPlaceholder': 'أدخل رقم الطلب',
    'step2.attachments': 'الاشتراطات المطلوبة',
    'step2.attachmentsDescription': 'حدد الاشتراطات التي تريد التحقق منها من القائمة أدناه',
    'step2.customAttachment': 'إضافة اشتراط مخصص',
    'step2.customAttachmentPlaceholder': 'أدخل اسم الاشتراط',
    'step2.addCustom': 'إضافة',
    'step2.nextButton': 'متابعة ←',
    'step2.validation.civilIdRequired': 'رقم الهوية مطلوب',
    'step2.validation.civilIdInvalid': 'رقم الهوية يجب أن يتكون من 10 أرقام',
    'step2.validation.requesterNameRequired': 'اسم مقدم الطلب مطلوب',
    'step2.validation.attachmentsRequired': 'يرجى اختيار اشتراط واحد على الأقل',
    'step2.validation.customAttachmentEmpty': 'يرجى إدخال اسم الاشتراط',
    'step2.loadingText': 'جاري التحقق من الاشتراطات',

    // Step 3
    'step3.title': 'الخطوة 3: تقرير التحقق والاعتماد',
    'step3.description': 'مراجعة نهائية لجميع الوثائق والبيانات القيمة المقدمة',
    'step3.printReport': 'طباعة التقرير',
    'step3.newValidation': 'التحقق من طلب جديد',
    'step3.deedNumber': 'رقم الصك',
    'step3.civilId': 'رقم الهوية',
    'step3.tab.report': 'التقرير',
    'step3.tab.segments': 'أقسام المستند',
    'step3.tab.chat': 'محادثة',
    'step3.viewGrid': 'شبكي',
    'step3.viewTable': 'جدولي',
    'step3.matchedRequirements': 'اشتراطات مطابقة',
    'step3.unmatchedRequirements': 'اشتراطات غير مطابقة',
    'step3.totalRequirements': 'إجمالي الاشتراطات',
    'step3.matchedFields': 'تفاصيل المطابقة',
    'step3.expected': 'المتوقع:',
    'step3.found': 'الموجود:',
    'step3.matched': 'مطابق',
    'step3.notMatched': 'غير مطابق',
    'step3.noFieldsToCompare': 'لا توجد حقول للمقارنة',
    'step3.aiSnippet': '(AI Snippet) مقطع الدليل',
    'step3.confidence': 'دقة',
    'step3.confidenceLabel': 'نسبة الثقة:',
    'step3.preview': 'معاينة',
    'step3.previewEvidence': 'معاينة الأدلة',
    'step3.noEvidence': 'لا توجد أدلة مرئية لهذه القاعدة',
    'step3.noPreviewImage': 'لا توجد صورة للعرض',
    'step3.thumbnailsHint': 'انقر على أي "دليل" في اليمين لتحديث معاينة المستند تلقائياً',
    'step3.document': 'المستند',
    'step3.of': 'من',
    'step3.page': 'صفحة',
    'step3.pages': 'صفحات',
    'step3.loadingText': 'جاري التحقق من الاشتراطات',
    'step3.loadingDatalab': 'جاري تحويل ومعالجة المستندات',
    'step3.loadingAI': 'جاري التحقق من الاشتراطات',
    'step3.noDataAvailable': 'لا توجد بيانات متاحة للعرض',
    'step3.startOver': 'اضغط هنا للبدء من جديد',
    'step3.toast.validationSuccess': 'اكتملت عملية التحقق بنجاح',
    'step3.toast.validationFailed': 'فشل التحقق - يرجى المحاولة مرة أخرى',
    'step3.toast.noEvidenceForRule': 'لا توجد أدلة مرئية لهذه القاعدة',
    'step3.datalabTime': 'وقت معالجة المستند',
    'step3.aiTime': 'وقت مطابقة الاشتراطات',
    'step3.totalTime': 'الوقت الإجمالي',
    'step3.chat.title': 'محادثة مع المستند',
    'step3.chat.placeholder': 'اطرح سؤالاً حول المستند...',
    'step3.chat.send': 'إرسال',
    'step3.chat.clear': 'مسح المحادثة',
    'step3.chat.loading': 'جاري التفكير...',
    'step3.chat.empty': 'ابدأ محادثة بطرح سؤال حول المستند',
    'step3.chat.error': 'فشل الحصول على إجابة. يرجى المحاولة مرة أخرى',
    'step3.chat.retry': 'إعادة المحاولة',
    'step3.chat.copy': 'نسخ',
    'step3.chat.copied': 'تم النسخ',
    'step3.chat.evidence': 'الدليل',
    
    // Status
    'status.passed': 'ناجح',
    'status.failed': 'مرفوض',
    'status.notApplicable': 'غير منطبق',
    'status.needsReview': 'يحتاج مراجعة',
    'status.success': 'اكتملت المراجعة بنجاح',
    'status.partial': 'مراجعة جزئية - يوجد متطلبات ناقصة',
    'status.failedReview': 'فشلت المراجعة',
    'status.needsAdditionalReview': 'يحتاج إلى مراجعة إضافية',

    // Segments
    'segments.title': 'أقسام المستند المستخرجة',
    'segments.count': '{count} قسم',
    'segments.imagesAvailable': '{count} صورة متاحة',
    'segments.noThumbnails': 'لا توجد صور متاحة لهذا القسم',
    'segments.noData': 'لا توجد بيانات تقسيم متاحة',

    // Settings
    'settings.title': 'إعدادات الاشتراطات',
    'settings.close': 'إغلاق',
    
    // Common
    'common.loading': 'جاري التحميل...',
    'common.error': 'حدث خطأ',
    'common.retry': 'إعادة المحاولة',
    'common.close': 'إغلاق',
    'common.save': 'حفظ',
    'common.cancel': 'إلغاء',
    'common.yes': 'نعم',
    'common.no': 'لا',
  },
  
  en: {
    // Header
    'header.title': 'AI Requirements Validation System',
    'header.settings': 'Settings',
    'header.language': 'Change Language',
    
    // Footer
    'footer.disclaimer': 'This is a demo version not intended for production use, aimed at testing AI-based requirements validation. Outputs are not final decisions. For internal use by authorized personnel only.',
    'footer.copyright': '©Barqium. All rights reserved.',

    // Step 1 (Upload)
    'step1.title': 'Step 1: Upload Documents',
    'step1.description': 'Please upload PDF files for validation and processing by Barqium AI system.',
    'step1.dropzone': 'Drag and drop PDF files here or click to browse',
    'step1.dropzoneHint': 'Maximum file size: 50MB (PDF format only)',
    'step1.browseFiles': 'Browse files from your device',
    'step1.uploadedFiles': 'Uploaded Files',
    'step1.fileSize': 'MB',
    'step1.fileUploaded': 'Uploaded',
    'step1.fileConverting': 'Converting...',
    'step1.convertButton': 'Convert & Continue →',
    'step1.converting': 'Converting...',
    'step1.loadingText': 'Converting and processing documents',
    'step1.validation.noFiles': 'Please upload at least one file',
    'step1.validation.invalidType': 'The following files are not PDF format',
    'step1.validation.fileTooLarge': 'The following files exceed maximum size (50MB)',
    'step1.validation.maxFiles': 'Maximum files allowed is {max}. You have {current} file(s) and trying to add {adding}.',
    'step1.toast.convertSuccess': 'Successfully converted {count} file(s)',
    'step1.toast.convertFailed': 'Failed to convert files',

    // Step 2 (Rules)
    'step2.title': 'Step 2: Define Requirements',
    'step2.description': 'Please enter the requirements you want to validate from the list below',
    'step2.civilId': 'National ID Number',
    'step2.civilIdPlaceholder': 'Enter ID number',
    'step2.requesterName': 'Requester Name',
    'step2.requesterNamePlaceholder': 'Enter full name',
    'step2.requestId': 'Request Number',
    'step2.requestIdPlaceholder': 'Enter request number',
    'step2.attachments': 'Required Requirements',
    'step2.attachmentsDescription': 'Select the requirements you want to validate from the list below',
    'step2.customAttachment': 'Add Custom Requirement',
    'step2.customAttachmentPlaceholder': 'Enter requirement name',
    'step2.addCustom': 'Add',
    'step2.nextButton': 'Continue →',
    'step2.validation.civilIdRequired': 'National ID is required',
    'step2.validation.civilIdInvalid': 'National ID must be 10 digits',
    'step2.validation.requesterNameRequired': 'Requester name is required',
    'step2.validation.attachmentsRequired': 'Please select at least one requirement',
    'step2.validation.customAttachmentEmpty': 'Please enter requirement name',
    'step2.loadingText': 'Validating documents',

    // Step 3
    'step3.title': 'Step 3: Validation & Approval Report',
    'step3.description': 'Final review of all submitted documents and data',
    'step3.printReport': 'Print Report',
    'step3.newValidation': 'New Validation',
    'step3.deedNumber': 'Deed Number',
    'step3.civilId': 'Civil ID',
    'step3.tab.report': 'Report',
    'step3.tab.segments': 'Document Segments',
    'step3.tab.chat': 'Chat',
    'step3.viewGrid': 'Grid',
    'step3.viewTable': 'Table',
    'step3.matchedRequirements': 'Matched Requirements',
    'step3.unmatchedRequirements': 'Unmatched Requirements',
    'step3.totalRequirements': 'Total Requirements',
    'step3.matchedFields': 'Match Details',
    'step3.expected': 'Expected:',
    'step3.found': 'Found:',
    'step3.matched': 'Matched',
    'step3.notMatched': 'Not Matched',
    'step3.noFieldsToCompare': 'No fields to compare',
    'step3.aiSnippet': 'AI Evidence Snippet',
    'step3.confidence': 'Confidence',
    'step3.confidenceLabel': 'Confidence:',
    'step3.preview': 'Preview',
    'step3.previewEvidence': 'Evidence Preview',
    'step3.noEvidence': 'No visual evidence available for this rule',
    'step3.noPreviewImage': 'No image to display',
    'step3.thumbnailsHint': 'Click any evidence on the right to update the document preview',
    'step3.document': 'Document',
    'step3.of': 'of',
    'step3.page': 'Page',
    'step3.pages': 'Pages',
    'step3.loadingText': 'Validating documents',
    'step3.loadingDatalab': 'Converting and processing documents',
    'step3.loadingAI': 'Validating requirements',
    'step3.noDataAvailable': 'No data available to display',
    'step3.startOver': 'Click here to start over',
    'step3.toast.validationSuccess': 'Validation completed successfully',
    'step3.toast.validationFailed': 'Validation failed - please try again',
    'step3.toast.noEvidenceForRule': 'No visual evidence available for this rule',
    'step3.datalabTime': 'Document Processing Time',
    'step3.aiTime': 'AI Matching Time',
    'step3.totalTime': 'Total Time',
    'step3.chat.title': 'Chat with Document',
    'step3.chat.placeholder': 'Ask a question about the document...',
    'step3.chat.send': 'Send',
    'step3.chat.clear': 'Clear Chat',
    'step3.chat.loading': 'Thinking...',
    'step3.chat.empty': 'Start a conversation by asking a question about the document',
    'step3.chat.error': 'Failed to get response. Please try again',
    'step3.chat.retry': 'Retry',
    'step3.chat.copy': 'Copy',
    'step3.chat.copied': 'Copied',
    'step3.chat.evidence': 'Evidence',
    
    // Status
    'status.passed': 'Passed',
    'status.failed': 'Failed',
    'status.notApplicable': 'Not Applicable',
    'status.needsReview': 'Needs Review',
    'status.success': 'Review completed successfully',
    'status.partial': 'Partial review - missing requirements',
    'status.failedReview': 'Review failed',
    'status.needsAdditionalReview': 'Needs additional review',

    // Segments
    'segments.title': 'Extracted Document Segments',
    'segments.count': '{count} segment(s)',
    'segments.imagesAvailable': '{count} image(s) available',
    'segments.noThumbnails': 'No images available for this segment',
    'segments.noData': 'No segmentation data available',

    // Settings
    'settings.title': 'Requirements Settings',
    'settings.close': 'Close',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.retry': 'Retry',
    'common.close': 'Close',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.yes': 'Yes',
    'common.no': 'No',
  }
};
